module.exports = __webpack_public_path__ + "img/6.e4eab7e4.png";